<template>
  <div
    class="mt-2"
  >
    <v-expand-transition>
      <div
        v-if="showTextArea"
      >
        <TextInput
          ref="textInput"
          @cancel="cancel"
          @save="save"
        />
      </div>
    </v-expand-transition>
    <button
      v-if="showButton"
      @click="toggleInput"
    >
      <span class="addText">
        {{ $t('actions.addReply') }}
      </span>
    </button>
  </div>
</template>
<script>
import TextInput from '../TextInput';

export default {
  name: 'ThreadInput',
  components: {
    TextInput,
  },
  data() {
    return {
      showTextArea: false,
      showButton: true,
      text: '',
    };
  },
  methods: {
    save({ text }) {
      this.text = text;
      this.$emit('save', text);
      this.toggleInput();
    },
    cancel() {
      this.toggleInput();
    },
    toggleInput() {
      if (this.showButton) {
        this.showTextArea = true;
        this.showButton = false;
        this.$nextTick(() => this.$refs.textInput.$refs.textArea.focus());
      } else {
        this.showTextArea = false;
        this.showButton = true;
      }
    },
  },
};
</script>
<style scoped>
.addText {
  font-size: 11px;
  color: #8f979f;
}

.addText:hover {
  color: #3C44C8;
}
</style>
